import { Globe, MoreHoriz } from "iconoir-react";
import type { Post } from "@/types/posts";
import { getCategoryTagStyle } from "./utils";

interface PostHeaderProps {
  post: Post;
  onOptionsClick: (e: React.MouseEvent) => void;
}

export function PostHeader({ post, onOptionsClick }: PostHeaderProps) {
  const tagStyle = getCategoryTagStyle(String(post.category));

  return (
    <div className="flex justify-between items-center p-4 pb-3">
      <div className="flex items-center gap-3">
        <img
          className="size-10 rounded-full"
          src={
            typeof post.author.avatar_url === "string" && post.author.avatar_url
              ? post.author.avatar_url
              : "/avatars/kiki.svg"
          }
          alt={post.author.display_name ? String(post.author.display_name) : ""}
        />
        <div>
          <div className="flex items-center gap-1.5">
            <h3 className="font-medium text-base text-[#1E3A3A]">
              {post.author.display_name}
            </h3>
            <span
              className={`${tagStyle.bg} ${tagStyle.text} text-[10px] px-3 py-0.5 rounded-full`}
            >
              {tagStyle.label}
            </span>
          </div>
          <div className="flex items-center text-[#6F6F6B] text-xs gap-1.5">
            <span>{post.author.location || "Washington, DC"}</span>
            <div className="w-0.5 h-0.5 rounded-full bg-[#6F6F6B]"></div>
            <span>1d</span>
            <div className="w-0.5 h-0.5 rounded-full bg-[#6F6F6B]"></div>
            <span className="flex items-center">
              <Globe className="w-4 h-4 text-[#6F6F6B]" />
            </span>
          </div>
        </div>
      </div>
      <button className="p-1" onClick={onOptionsClick}>
        <MoreHoriz className="w-6 h-6 text-[#1E3A3A]" />
      </button>
    </div>
  );
}
